import { useAtom } from '@reatom/npm-react'
import React, { useMemo } from 'react'

import { Numeric } from '@blade/ui-kit'
import { nativePriceAtom } from '@root/features/realtime/atoms'

import type BigNumber from 'bignumber.js'

type InstantTradeQuoteUsdProps = {
  amountNative: BigNumber
}

export const TradingControlsQuoteUsd = React.memo(
  ({ amountNative }: InstantTradeQuoteUsdProps) => {
    const [nativePrice] = useAtom(nativePriceAtom)

    const priceUsd = useMemo(
      () => amountNative.multipliedBy(nativePrice),
      [amountNative, nativePrice],
    )

    if (priceUsd.isZero()) {
      return undefined
    }

    return (
      <span>
        <span> (</span>
        <Numeric
          value={priceUsd}
          preset={'currency-amount-short'}
          mantissa={2}
          currency="$"
        />
        <span>)</span>
      </span>
    )
  },
)
